import moment from 'moment-timezone';

import { Event } from '../interfaces';

export const getTimeOffset = (firstEvent: Event, lastEvent: Event, withDelta = true): string => {
  const rootEvent = moment(firstEvent.captured_at);
  const event = moment(lastEvent.captured_at);
  const diff = rootEvent.diff(event);
  const roundedDiff = Math.floor(Math.abs(diff) / 60_000) * 60_000;

  const isBefore = event.isBefore(rootEvent);

  const duration = moment.duration(roundedDiff).humanize({ m: 60, h: 24 });

  if (withDelta) {
    let r = isBefore ? '-' : '+';
    r += duration;
    return r;
  }

  return duration;
};
